(function() {
	// register global events (for entire site)
	$(document).on('click', '[data-toggle="lightbox"]', function(t) {
		t.preventDefault(), $(this).ekkoLightbox(
			{
				alwaysShowClose: true,
				showArrows: true
			}
		);
	});

	$(document).on('scroll', function() {
		var msthead = $('#masthead').position().top;
		var windowSizeWide = $(window).width();
		if (msthead !== 0) {
			msthead = $('#masthead').position().top - 10;
		} else {
			if (windowSizeWide <= 576) {
				msthead = 39;
			} else if (windowSizeWide <= 768) {
				msthead = 51;
			} else {
				msthead = 59;
			}
		}
		window.pageYOffset >= msthead ? $('#masthead').addClass('shrink') : $('#masthead').removeClass('shrink');
	});

	$(document).on('submit', '.js-search-form', function(ev) {
		ev.preventDefault();
		var el = $(ev.currentTarget);
		var searchterm = $('.js-search-form').serialize();
		if (WebBaseAprovLV.lang === 'de') {
			page('/' + WebBaseAprovLV.lang + '/suche?' + searchterm);
		} else if (WebBaseAprovLV.lang === 'lld') {
			page('/' + WebBaseAprovLV.lang + '/chirida?' + searchterm);
		} else if (WebBaseAprovLV.lang === 'en') {
			page('/' + WebBaseAprovLV.lang + '/search?' + searchterm);
		} else {
			page('/' + WebBaseAprovLV.lang + '/ricerca?' + searchterm);
		}
		$('#q').val('');
	});

	$(document).on('submit', '.js-search-form-mobile', function(ev) {
		ev.preventDefault();
		var el = $(ev.currentTarget);
		var searchterm = $('.js-search-form-mobile').serialize();
		if (WebBaseAprovLV.lang === 'de') {
			page('/' + WebBaseAprovLV.lang + '/suche?' + searchterm);
		} else if (WebBaseAprovLV.lang === 'lld') {
			page('/' + WebBaseAprovLV.lang + '/chirida?' + searchterm);
		} else if (WebBaseAprovLV.lang === 'en') {
			page('/' + WebBaseAprovLV.lang + '/search?' + searchterm);
		} else {
			page('/' + WebBaseAprovLV.lang + '/ricerca?' + searchterm);
		}
		$('#qmobile').val('');
	});

	$(document).on('submit', '.js-search-form-sidebar', function(ev) {
		ev.preventDefault();
		var el = $(ev.currentTarget);
		var searchterm = $('.js-search-form-sidebar').serialize();
		if (WebBaseAprovLV.lang === 'de') {
			page('/' + WebBaseAprovLV.lang + '/suche?' + searchterm);
		} else if (WebBaseAprovLV.lang === 'lld') {
			page('/' + WebBaseAprovLV.lang + '/chirida?' + searchterm);
		} else if (WebBaseAprovLV.lang === 'en') {
			page('/' + WebBaseAprovLV.lang + '/search?' + searchterm);
		} else {
			page('/' + WebBaseAprovLV.lang + '/ricerca?' + searchterm);
		}
		$('#sidebar').val('');
	});

	$(document).on('submit', '.js-search-inpage', function(ev) {
		ev.preventDefault();
		var el = $(ev.currentTarget);
		var searchterm = $('.js-search-inpage').serialize();
		if (WebBaseAprovLV.lang === 'de') {
			page('/' + WebBaseAprovLV.lang + '/suche?' + searchterm);
		} else if (WebBaseAprovLV.lang === 'lld') {
			page('/' + WebBaseAprovLV.lang + '/chirida?' + searchterm);
		} else if (WebBaseAprovLV.lang === 'en') {
			page('/' + WebBaseAprovLV.lang + '/search?' + searchterm);
		} else {
			page('/' + WebBaseAprovLV.lang + '/ricerca?' + searchterm);
		}
	});

	$(document).on('submit', '.js-search-facets', function(ev) {
		ev.preventDefault();
		var el = $(ev.currentTarget);
		const strpage = el[0].action;
		const targetpage = strpage.substring(strpage.indexOf('#!') + 2);
		var searchterm = $('.js-search-facets').serialize();
		page(targetpage + '#' + searchterm);
	});

	$(document).on('submit', '.js-search-facets-param', function(ev) {
		ev.preventDefault();
		var el = $(ev.currentTarget);
		const strpage = el[0].action;
		const targetpage = strpage.substring(strpage.indexOf('#!') + 2);
		var searchterm = $('.js-search-facets-param').serialize();
		page(targetpage + '?' + searchterm);
	});

	$(document).on('click', '#localanchor a[href*=\\#]', function(event) {
		var lnkanchor = this.hash;
		var windowSizeWide = $(window).width();
		var additionalOffset = 133;
		if (windowSizeWide <= 576) {
			additionalOffset = 110;
		} else if (windowSizeWide <= 991) {
			additionalOffset = 133;
		}
		event.preventDefault();
		$('html, body').animate({
			scrollTop: $('[name="' + lnkanchor.replace('#', '') + '"]').offset().top - 133
		}, 500);
		return false;
	});


})();
